import { ComponentProps } from "react";
import {
  NumericFormat as ReactNumericFormat,
  NumericFormatProps,
} from "react-number-format";

import { cn } from "@bentolabs/kit/utils";
import { cva, VariantProps } from "class-variance-authority";

const variants = cva(["inline-flex bg-transparent outline-hidden"], {
  variants: {
    variant: {
      default: ["text-white text-[26px] leading-none"],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

// const isAllowed = (values: NumberFormatValues) => {
//   const { value } = values;
//   if (value[0] && value[1] && value[0] === "0" && value[1] !== ".")
//     return false;

//   return true;
// };

export type NumericInputProps = NumericFormatProps &
  VariantProps<typeof variants> & {
    ref?: ComponentProps<"input">["ref"];
  };

export const NumericInput = ({
  className,
  variant,
  ref,
  onValueChange,
  ...props
}: NumericInputProps) => {
  return (
    <ReactNumericFormat
      getInputRef={ref}
      inputMode="decimal"
      autoComplete="off"
      className={cn(variants({ variant, className }))}
      allowNegative={false}
      allowedDecimalSeparators={[".", ","]}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source !== "event") return;
        onValueChange?.(values, sourceInfo);
      }}
      {...props}
    />
  );
};
